import React, {useContext, useRef, useEffect, useState, useLayoutEffect} from "react";
import useRequest from "~/common/hooks/useRequest";
import ReactQuill, { Quill } from "react-quill";
import ImageResize from "quill-image-resize-module-react";
import Form, { Group } from "~/common/components/Form";
import Input from "~/common/components/Input";
import Textarea from "~/common/components/textarea";
import SingleImageUploader from "~/common/components/ImageUploader/SingleImageUploader";
import { UPLOAD_TYPE } from "~/common/constants/upload";
import DatePicker from "~/common/components/DatePicker";
import Select from "~/common/components/Select";
import Address from "~/common/components/Address";
import "~/assets/sass/pages/round/roundReg/edit.scss";
import { EarthIcon, QuestionMarkIcon } from "~/assets/svg/InterfaceIcon";
import { AppContext } from "../RoundRegContext";
import { API_STATE } from "~/common/constants/state";
import { ROUND_SUBMIT } from "~/common/components/ImageUploader/ImagePath";
import "rc-slider/assets/index.css";
import CompanySelectModal from "~/pages/round/RoundReg/components/CompanySelectModal";
import { useTranslation } from "react-i18next";
import translation from "~/i18n";
import i18n from "i18next";
import FileUploaderAdd from "~/common/components/FileUploaderAdd";
import RoundReview from "~/pages/round/RoundReg/Edit/RoundReview";

Quill.register("modules/imageResize", ImageResize);

const quillModules = {
	imageResize: {
		displayStyles: {
			backgroundColor: "black",
			border: "none",
			color: "white",
		},
		modules: ["Resize", "DisplaySize", "Toolbar"],
	},
	toolbar: [
		["bold", "italic", "underline", "strike", "blockquote"],
		[{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
		["link", "image"],
		["clean"],
	],
};

const quillFormats = [
	"header",
	"bold",
	"italic",
	"underline",
	"strike",
	"blockquote",
	"list",
	"bullet",
	"indent",
	"link",
	"image",
];

const Edit = ({ targetModifyIdx, setStep, reviewSettingData, setReviewSettingData }) => {
	const {
		roundRegForm,
		detailContent,
		setDetailContent,
		mainImg,
		externalLink,
		setExternalLink,
		check,
		setCheck,
		setRegisterWay,
		modEdit,
		fileList,
		setFileList,
		companyList,
		setCompanyList,
		snsValueList,
		setSnsValueList,
	} = useContext(AppContext);

	const { t } = useTranslation();

	// 지원 프로그램 수정시 돌리는 로직
	const quillRef = useRef(null);
	const [tmpImg, setTmpImg] = useState("");
	const [selectCompanyModal, setSelectCompanyModal] = useState(false);
	const selectWay = roundRegForm.watch("way") || "온라인 질의 작성하기";
	const selectPlace = roundRegForm.watch("place") || "온라인접수";

	const uploadImgRequest = useRequest("post", "file/vc/upload");
	const industryRequest = useRequest("get", "vc/portfolio/industry");
	const [options, setOptions] = useState([]);

	const startDate = roundRegForm.watch("applyStartDate");
	const endDate = roundRegForm.watch("applyEndDate");


	useEffect(() => {
		setRegisterWay(selectWay);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectWay]);

	useEffect(() => {
		if (modEdit) {
			const checkedCompanyList = modEdit.companyList.map((company) => {
				return { ...company, checked: true };
			});

			setCompanyList(checkedCompanyList);
		}
	}, [modEdit]);

	useEffect(() => {
		roundRegForm.setValue(
			"startupCompanyIdxList",
			companyList
				.filter((company) => company.checked === true)
				.map((company) => {
					return company.idx;
				})
		);
	}, [companyList]);

	const setMainImg = (signature) => {
		roundRegForm.setValue("sign", signature);
	};

	const uploadImage = async (file, filePath) => {
		if (file.type.includes("image")) {
			const formData = new FormData();
			formData.append("path", filePath);
			formData.append("type", "지원 프로그램 정보");
			formData.append("file", file);

			await uploadImgRequest.call(formData);
		} else {
			alert(t("pages.round.RoundReg.Edit.checkImg"));
		}
	};

	useEffect(() => {
		switch (uploadImgRequest.state) {
			case API_STATE.done:
				const responseData = uploadImgRequest.response.data;
				setTmpImg(responseData);
				break;
			case API_STATE.loading:
				break;
			case API_STATE.error:
				break;
			default:
				break;
		}
	}, [uploadImgRequest.state, uploadImgRequest.response, uploadImgRequest.error]);

	useEffect(() => {
		switch (industryRequest.state) {
			case API_STATE.done:
				const industryApiList = industryRequest.response?.data;
				let tmpArr = [];
				industryApiList.map((industArr) => {
					tmpArr.push({
						label: i18n.language === "ko" ? industArr.name : industArr.engName,
						value: industArr.idx,
					});
				});
				setOptions(tmpArr);
				break;
			default:
				break;
		}
	}, [industryRequest.state, industryRequest.response]);

	useEffect(() => {
		if (tmpImg !== "") {
			const { getEditor } = quillRef.current;
			//getEditor().deleteText(range.index, 1);
			const range = getEditor().getSelection(true);
			getEditor().insertEmbed(range.index, "image", tmpImg);

			// 사용자 편의를 위해 커서 이미지 오른쪽으로 이동
			getEditor().setSelection(range.index + 1);
		}
	}, [tmpImg]);

	useEffect(() => {
		industryRequest.call();
		const handleImage = () => {
			const { getEditor } = quillRef.current;
			const input = document.createElement("input");
			input.setAttribute("type", "file");
			input.setAttribute("accept", "image/*");
			input.click();
			input.onchange = async () => {
				const file = input.files[0];

				// 현재 커서 위치 저장
				const range = getEditor().getSelection(true);

				//getEditor().insertEmbed(range.index, "image", `/images/loading.gif`);

				try {
					const filePath = `round/info`;
					await uploadImage(file, filePath);
				} catch (e) {
					getEditor().deleteText(range.index, 1);
				}
			};
		};

		if (quillRef.current) {
			const toolbar = quillRef.current.getEditor().getModule("toolbar");
			toolbar.addHandler("image", handleImage);
		}
	}, []);

	const onChangeIndus = (data, index, value) => {
		let copySnsList = [...snsValueList];

		copySnsList[index][data] = value;

		setSnsValueList(copySnsList);
	};
	// 진행중
	// const doReadOnly = roundStatus === "roundEdit" && modEdit?.status === "진행중";
	const doReadOnly = false;

	const clickSelectCompany = () => {
		setSelectCompanyModal(true);
	};

	const selectedCompanyText = () => {
		const selectedCompanyList = companyList.filter((company) => company.checked === true);
		if (selectedCompanyList.length === 1) {
			return `${selectedCompanyList[0].name} ${t("pages.round.RoundReg.Edit.selectedOne")}`;
		} else if (selectedCompanyList.length > 1) {
			return `${t("pages.round.RoundReg.Edit.selectedTotal")}${selectedCompanyList.length}${t(
				"pages.round.RoundReg.Edit.selectedTotal2"
			)}`;
		} else {
			return `${t("pages.round.RoundReg.Edit.selectedAll")}`;
		}
	};

	return (
		<>
			<div className="c__card">
				<Form useForm={roundRegForm}>
					<Input
						label={t("pages.round.RoundReg.Edit.title")}
						placeholder="지원 프로그램 제목을 작성해 주세요."
						name="roundTitle"
						required
						readonly={doReadOnly}
					/>
					<div className="f__group required">
						<div className="f__label">
							{t("pages.round.RoundReg.Edit.detail")}
							<div className="c__tooltip-btn">
								<QuestionMarkIcon />
								<p className="c__tooltip short">
									이미지, 영상, 링크 등을 활용해 지원 프로그램에 대한 정보를 작성할 수
									있습니다.
								</p>
							</div>
						</div>
						<div className="f__control">
							<ReactQuill
								ref={quillRef}
								theme={doReadOnly ? "bubble" : "snow"}
								modules={{
									...quillModules,
									imageResize: {
										parchment: Quill.import("parchment"),
										modules: ["Resize", "DisplaySize", "Toolbar"],
									},
								}}
								formats={quillFormats}
								value={detailContent}
								onChange={(e) => setDetailContent(e)}
								placeholder="지원 프로그램 관련 상세 내용을 작성해 주세요."
								readOnly={doReadOnly}
							/>
						</div>
					</div>
					<Textarea
						label={t("pages.round.RoundReg.Edit.shortDesc")}
						name="introduction"
						placeholder="50자 내외로 지원 프로그램에 대한 설명을 작성해 주세요."
						callback={() => {
							if (roundRegForm.watch("introduction").length > 50) {
								return roundRegForm.setError("introduction", {
									type: "maxLength",
									message: "50 글자를 초과하여 작성할 수 없습니다.",
								});
							}
							roundRegForm.clearErrors("introduction");
						}}
						showCount
						maxLength={50}
						canOver
						readonly={doReadOnly}
						required
						className="desc"
					/>
					<Group label={t("pages.round.RoundReg.Edit.file")}>
						<FileUploaderAdd
							name="file"
							format=".pdf, .hwp, .docx, .xlsx, .ppt, ,pptx, .jpg, .jpeg, .png, .keynote"
							fileList={fileList}
							setFileList={setFileList}
							type={{ type: "라운드 첨부파일", path: "round" }}
						/>
					</Group>
					<div className="f__group required">
						<div className="f__label">
							{t("pages.round.RoundReg.Edit.img")}
							<span className="">
								{t("pages.round.RoundReg.Edit.optimumSize")}(570x342)
							</span>
						</div>
						<div className="f__control">
							<SingleImageUploader
								uploaderConstant={UPLOAD_TYPE.COMMON}
								width={173}
								height={104}
								img={mainImg}
								setImg={setMainImg}
								path={ROUND_SUBMIT}
								readonly={doReadOnly}
							/>
						</div>
					</div>
					<Group
						label={t("pages.round.RoundReg.Edit.period")}
						className="datePicker-group"
						required
					>
						<DatePicker name="applyStartDate" readonly={doReadOnly} maxDate={endDate} />
						<span className="dash"> - </span>
						<DatePicker name="applyEndDate" minDate={startDate} />
					</Group>
					<Group
						label={
							<>
								{t("pages.round.RoundReg.Edit.method")}
								<div className="c__tooltip-btn">
									<QuestionMarkIcon />
									<p className="c__tooltip long">
										* 접수 방법
										<br />① 온라인 질의 작성하기 : 직접 온라인 질의서를 작성해서
										심사에 필요한 답변을 확인할 수 있습니다. <br />② 온라인 :
										외부 링크에서 지원 프로그램 지원 기업을 모집할 수 있습니다. <br />③
										오프라인 : 접수 장소의 주소를 등록할 수 있습니다.
									</p>
								</div>
							</>
						}
						className="method-group"
						required
					>
						<Select
							name="way"
							options={[
								{
									label: translation.t("pages.round.RoundReg.Edit.createQuery"),
									value: "온라인 질의 작성하기",
								},
								{
									label: translation.t("pages.round.RoundReg.Edit.externalLink"),
									value: "온라인",
								},
								{
									label: translation.t("pages.round.RoundReg.Edit.externalLink2"),
									value: "오프라인",
								},
							]}
							className="select-wrap"
							defaultValue={selectWay}
							required
							disabled={doReadOnly}
						/>

						{/*온라인질의작성 버튼*/}
						{selectWay === "온라인 질의 작성하기" ? (
							<button
								type="button"
								className="btn__outline btn-create"
								color="primary"
								onClick={() => setStep("inquiry")}
								disabled={doReadOnly}
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="22px"
									height="24px"
									viewBox="0 0 22 24"
								>
									<path d="M20.000,4.000 L18.000,4.000 L18.000,2.000 L17.000,2.000 L17.000,4.000 L15.000,4.000 L15.000,5.000 L17.000,5.000 L17.000,7.000 L18.000,7.000 L18.000,5.000 L20.000,5.000 L20.000,4.000 ZM22.000,4.500 C22.000,6.985 19.983,9.000 17.500,9.000 C15.016,9.000 13.000,6.985 13.000,4.500 C13.000,2.014 15.016,-0.000 17.500,-0.000 C19.983,-0.000 22.000,2.014 22.000,4.500 ZM5.000,7.000 L11.500,7.000 C11.366,6.679 11.263,6.344 11.180,6.000 L5.000,6.000 L5.000,7.000 ZM18.000,10.974 C18.000,12.136 18.000,13.083 18.000,13.543 C18.000,17.650 12.000,16.000 12.000,16.000 C12.000,16.000 13.517,22.000 9.362,22.000 C7.495,22.000 8.893,22.000 2.000,22.000 L2.000,2.000 L11.500,2.000 C11.812,1.251 12.263,0.576 12.816,-0.000 L-0.000,-0.000 L-0.000,24.000 L10.189,24.000 C13.351,24.000 20.000,16.777 20.000,14.385 L20.000,10.500 C19.377,10.760 18.703,10.921 18.000,10.974 ZM12.816,9.000 L5.000,9.000 L5.000,10.000 L14.047,10.000 C13.597,9.716 13.183,9.381 12.816,9.000 ZM5.000,12.000 L15.000,12.000 L15.000,13.000 L5.000,13.000 L5.000,12.000 Z"></path>
								</svg>
								{t("pages.round.RoundReg.RoundRegContext.inquiry")}
							</button>
						) : selectWay === "온라인" ? (
							<div className="f__control external-link">
								<div className="f__control">
									<span className="icon-wrap">
										<EarthIcon />
									</span>
									<input
										className="c__input"
										name="link"
										placeholder="https://www.example.com"
										value={externalLink}
										onChange={(e) => setExternalLink(e.target.value)}
										readOnly={doReadOnly}
									/>
								</div>
							</div>
						) : (
							<Address
								name={{
									postCode: "zipCode",
									address1: "address",
									address2: "addressDetail",
								}}
								readonly={doReadOnly}
							/>
						)}
					</Group>
					<Group
						label={
							<>
								{t("pages.round.RoundReg.Edit.selectCompany-label")}
								<div className="c__tooltip-btn">
									<QuestionMarkIcon />
									<p className="c__tooltip long">
										지원 프로그램을 원하는 기업에게만 노출할 수 있는 기능입니다. <br />
										* 기업 선택 : 깃발 ST 회원으로 등록된 기업 중 선택하여
										지원 프로그램을 노출할 수 있습니다. <br />* 기업 미선택 : 모든 깃발
										ST 회원에게 지원 프로그램을 노출할 수 있습니다.
									</p>
								</div>
							</>
						}
						className="select-company-group"
					>
						<Input name="selectCompany" placeholder={selectedCompanyText()} readonly />
						<button
							className="btn__outline btn-create"
							color="primary"
							onClick={clickSelectCompany}
						>
							{t("pages.round.RoundReg.Edit.selectCompany-button")}
						</button>
					</Group>
					<Group
						label={
							<>
								{t("pages.round.RoundReg.Edit.host-label")}
								<div className="c__tooltip-btn">
									<QuestionMarkIcon />
									<p className="c__tooltip short">
										지원 프로그램 오픈 시 등록한 담당자 정보를 확인할 수 있으며 등록한
										메일로 기업들의 문의 메일이 발송될 수도 있습니다.
									</p>
								</div>
							</>
						}
						className="host-info-group"
						required
					>
						<Input
							name="hostName"
							placeholder={t("pages.round.RoundReg.Edit.hostName")}
							required
						/>
						<Input
							name="hostEmail"
							placeholder={t("pages.round.RoundReg.Edit.hostEmail")}
							required
						/>
					</Group>
					<Group
						label={
							<>
								{t("pages.round.RoundReg.Edit.sns")}
								<div className="c__tooltip-btn">
									<QuestionMarkIcon />
									<p className="c__tooltip short">
										VC 및 지원 프로그램 정보를 확인할 수 있는 SNS 채널을 추가할 수
										있습니다.
									</p>
								</div>
							</>
						}
						className="sns-info-wrap"
					>
						<div className="checkbox">
							{snsValueList.map((d, index) => {
								return (
									<label className={`checkbox-custom`} key={index}>
										<input
											type="checkbox"
											onChange={(e) =>
												onChangeIndus("checked", index, e.target.checked)
											}
											checked={d.checked}
											// disabled={doReadOnly}
										/>
										<span className="checkmark" />
										<span className="checkbox-label">{d.label}</span>
									</label>
								);
							})}
						</div>
						{snsValueList.map((d, index) => {
							const toggle = d.checked;

							return toggle ? (
								<div className="f__group sns-input-wrap" key={index}>
									<div className="f__label">{d.label}</div>
									<input
										name="facebook"
										className="c__input"
										placeholder={`${t(
											"pages.round.RoundReg.Edit.linkPlaceholder"
										)}`}
										onChange={(e) =>
											onChangeIndus("text", index, e.target.value)
										}
										value={d["text"]}
										// readOnly={doReadOnly}
									/>
								</div>
							) : (
								<div />
							);
						})}
					</Group>
					<Group
						label={
							<>
								{t("pages.round.RoundReg.Edit.inquiry")}
								<div className="c__tooltip-btn">
									<QuestionMarkIcon />
									<p className="c__tooltip short">
										활성화로 변경 시 자주 묻는 질문을 작성할 수 있습니다.
									</p>
								</div>
							</>
						}
						className="inquiry-group"
					>
						<div className="f__control">
							<label className="c__toggle">
								<input
									type="checkbox"
									checked={check}
									onChange={() => setCheck(!check)}
									disabled={doReadOnly}
								/>
								<div className="slider">
									<span className="background" />
									<span className="ball" />
								</div>
								{check ? (
									<span className="toggle-label">
										{t("pages.round.RoundReg.Edit.activate")}
									</span>
								) : (
									<span className="toggle-label">
										{t("pages.round.RoundReg.Edit.deactivate")}
									</span>
								)}
							</label>
						</div>
						{check ? (
							<button
								type="button"
								className="btn__outline btn-create"
								color="primary"
								onClick={() => setStep("question")}
								// disabled={doReadOnly}
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="22px"
									height="24px"
									viewBox="0 0 22 24"
								>
									<path
										className="st0"
										d="M15.8,4.8c-0.3-0.3-0.3-0.9,0-1.2l3.5-3.4C19.5,0.1,19.7,0,19.9,0c0.2,0,0.4,0.1,0.6,0.3L15.8,4.8z M10.1,13.4 C10,13.5,10,13.6,10,13.6c0,0.2,0.2,0.4,0.4,0.4c0.1,0,0.2,0,0.2-0.1l0.6-0.6l-0.5-0.5L10.1,13.4z M15,6.8l-2,1.9 c-1.1,1-1.6,2-2.1,3.5l0.9,0.9c1.4-0.5,2.4-1,3.5-2l2-1.9L15,6.8z M20.8,0.9l-5.1,5l2.6,2.7l5.1-5C23.8,3.2,24,2.7,24,2.2 C24,0.6,22-0.3,20.8,0.9z M9,13H5v1h4V13z M18,11.6v1.9c0,4.1-6,2.5-6,2.5s1.5,6-2.6,6H2V2h12.6l2.1-2H0v24h10.2 c3.2,0,9.8-7.2,9.8-9.6V9.7L18,11.6z"
									/>
								</svg>
								{t("pages.round.RoundReg.Edit.createQuestion")}
							</button>
						) : (
							<></>
						)}
					</Group>
				</Form>
			</div>

			{/*심사설정 */}
			<RoundReview
				{...{
					roundRegForm,
					reviewSettingData,
					setReviewSettingData,
					targetModifyIdx
				}}
			/>

			<CompanySelectModal
				{...{
					selectCompanyModal,
					setSelectCompanyModal,
					companyList,
					setCompanyList,
					options,
				}}
			/>
		</>
	);
};

export default Edit;
